/** Strip control / dangerous characters from medication text stored in the DB. */

const CTRL = /[\u0000-\u001F\u007F-\u009F]/g;

export function sanitizeMedTextField(raw: unknown, maxLen = 512): string {
  let s = String(raw ?? "");
  s = s.replace(CTRL, "");
  s = s.replace(/\s+/g, " ").trim();
  if (s.length > maxLen) s = s.slice(0, maxLen);
  return s;
}

const ALLOWED_STATUS = new Set<string>(["item_moved", "item_expired"]);

/** Only allow known status values; anything else becomes null. */
export function sanitizeMedStatus(raw: unknown): string | null {
  if (raw == null || raw === "") return null;
  const s = String(raw);
  return ALLOWED_STATUS.has(s) ? s : null;
}

export function sanitizeParsedMedTexts<T extends { name?: unknown; dosage?: unknown; unit?: unknown }>(
  m: T,
): T & { name: string; dosage: string; unit: string } {
  return {
    ...m,
    name: sanitizeMedTextField(m.name, 512),
    dosage: sanitizeMedTextField(m.dosage, 256),
    unit: sanitizeMedTextField(m.unit, 128),
  };
}
